import { memo } from 'react';

export default memo(function NotFound({}) {
  return (
    <div className="h-screen grid place-items-center text-h-1">
      404 Not Found
    </div>
  );
});
